export default __webpack_public_path__ + "static/media/rulerOn.23baece0.svg";